module.exports = __webpack_public_path__ + "img/mon_24.b0c48515.png";